export default function($) {
  $('.js-share-button').on( 'click', function() {
    $(this).hide();
    $('.js-share-links').show();
  });
  $('.js-share-close').on('click', function() {
    $('.js-share-links').hide();
    $('.js-share-button').show();
  })
}
